import React from 'react';
import { SvgIcon, Row, Col, ContentBlock, CourseImage } from 'seduo-ui';
const HorizontalCardNarrowerInitial = () => (<ContentBlock className="border">
        <Row className="course-row">
            <Col sm={4} lg={2} className="pr-sm-0">
                <a href={'#'}>
                    <CourseImage src={'https://dummyimage.com/222x150/9fa4a8/fff.png'} alt={'Default course image'} isFinished={false} overlayTextBottomRight={'1. kurz'}/>
                </a>
            </Col>
            <Col xs={10} sm={6} lg={9} className="pr-sm-0">
                <a href={'#'} className="course-row__info-title font-weight-medium" title="Course Title">
                    <div className="text-truncate-multiline text-truncate-multiline-2">Course Title</div>
                </a>
                <div className="course-row__info-subtitle">
                    <div className="mb-5">
                        <a href={'#'} className="course-row__info-link">
                            John Lector
                        </a>
                        ,{' '}
                        <a href={'#'} className="course-row__info-link">
                            Francis Teacher
                        </a>
                    </div>
                    <div className="course-row__info-text">123h 45m&nbsp;&middot;&nbsp;666 lekcí</div>
                </div>
            </Col>
            <Col xs={2} lg={1} className="text-center align-self-center px-0">
                <a href={'#'} role="button">
                    <SvgIcon kind="ArrowDown" size={10}/>
                </a>
            </Col>
        </Row>
    </ContentBlock>);
const Example = () => <HorizontalCardNarrowerInitial />;
export default Example;
